var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ConsigneeInfo',{attrs:{"consignee":_vm.barrel.Consignee}})
}
var staticRenderFns = []

export { render, staticRenderFns }